import React from "react";

export const CC = {
  ink: "#2A0E4F",
  brand: "#3D1677",
  purple: "#4C2380",
  border: "#DCCFEA",
  gold: "#C9A45C",
  serif: "'Fraunces', 'Times New Roman', serif",
  sans: "'Mulish', 'Segoe UI', sans-serif",
};

export const CrisClienteBrand = () => (
  <div className="flex flex-col items-center text-center" data-testid="cris-cliente-brand">
    <img src="/cliente-icons/symbol-light.png" alt="" aria-hidden="true"
      className="h-[84px] w-auto select-none sm:h-[96px]" draggable="false" />
    <div className="mt-2 text-[40px] font-semibold leading-none tracking-[-0.02em] sm:text-[46px]"
      style={{ color: CC.brand, fontFamily: CC.serif }}>
      Cris Cliente
    </div>
    <div className="mt-2.5 pl-[0.32em] text-[10px] font-bold uppercase tracking-[0.32em] sm:text-[11px]"
      style={{ color: CC.brand, fontFamily: CC.sans }}>
      Banco das Revendedoras
    </div>
    <div className="mt-4 h-[2px] w-12 rounded-full" style={{ background: CC.gold }} />
  </div>
);

export const BottomWaves = ({ children }) => (
  <div className="cc-waves relative mt-auto w-full overflow-hidden" data-testid="cris-cliente-waves">
    <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 170" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id="ccDeep" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#4A1E86" />
          <stop offset="1" stopColor="#5E2C98" />
        </linearGradient>
        <linearGradient id="ccGold" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#E9CF92" stopOpacity="0.2" />
          <stop offset="0.35" stopColor="#E3C27E" />
          <stop offset="1" stopColor="#F3DFA9" />
        </linearGradient>
      </defs>
      <path d="M0 18 C 90 40, 150 92, 400 70 L400 170 L0 170 Z" fill="#E6DAF6" />
      <path d="M0 60 C 120 50, 210 118, 400 92 L400 170 L0 170 Z" fill="#C9AEEA" opacity="0.9" />
      <path d="M0 92 C 110 70, 200 150, 400 118 L400 170 L0 170 Z" fill="url(#ccDeep)" />
      <path d="M0 106 C 120 92, 220 172, 400 120" fill="none" stroke="url(#ccGold)" strokeWidth="1.6" />
    </svg>
    <div className="relative">{children}</div>
  </div>
);
